import { Link } from "@tanstack/react-router";
import type { ChildCityType } from "@/helpers/cities";

export interface CityType {
  childCities?: ChildCityType;
  id: string;
  name: string;
  slug: string;
}

interface CitiesListProps {
  cities: CityType[];
}

interface CityProps {
  city: CityType;
}

function City({ city }: CityProps) {
  return (
    <>
      <li>
        <Link
          className="line-clamp-1 block whitespace-nowrap py-0.5 text-16/[1.875em] text-pale-lavender hover:underline"
          to={`/city/${city.slug}`}
        >
          {city.name}
        </Link>
      </li>
      {city.childCities?.data.map((child) => (
        <li className="pl-5" key={child.id}>
          <Link
            className="line-clamp-1 block whitespace-nowrap py-0.5 text-16/[1.875em] text-pale-lavender hover:underline"
            to={`/city/${child.attributes.slug}`}
          >
            {child.attributes.nameShort}
          </Link>
        </li>
      ))}
    </>
  );
}

export default function CitiesList({ cities }: CitiesListProps) {
  return (
    <ul className="columns-2 py-2 md:columns-3 lg:columns-4 xl:columns-6">
      {cities.map((city) => (
        <City city={city} key={city.id} />
      ))}
    </ul>
  );
}
